import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { Card, ResourceList, Avatar,  ResourceItem, Collapsible, TextContainer} from '@shopify/polaris';
import LogItem from "@presentational/transfer/components/LogItem";
const propTypes = {}

const TransfersList=(props)=>{

return(
  <Card>
    <ResourceList
      resourceName={{singular: 'Log Product', plural: 'Logs Products'}}
      items={props.transferItems}
      renderItem={(item) => {
        return (
          <LogItem
            product={item}
            symbol={props.symbol}
          />
        );
      }}
    />
  </Card>
) //End Return


}

TransfersList.propTypes = propTypes;
export default TransfersList;
